import "core-js/modules/es.object.to-string";
import "core-js/modules/es.promise";
import "core-js/modules/es.regexp.to-string";
import _Reflect$construct from "@babel/runtime-corejs3/core-js-stable/reflect/construct";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _classCallCheck from "@babel/runtime-corejs3/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime-corejs3/helpers/esm/createClass";
import _inherits from "@babel/runtime-corejs3/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs3/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs3/helpers/esm/getPrototypeOf";

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = _Reflect$construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !_Reflect$construct) return false;
  if (_Reflect$construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(_Reflect$construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2018,2020. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */


import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Switch, withRouter } from 'react-router-dom';
import { Authentication } from '@spm/universal-access';
import { CoreReduxActions } from '@spm/core';
import { TitledRoute, LoadingPage, AuthenticatedRoute } from '@spm/core-ui';
import Loadable from 'react-loadable';
import applicationHeaderTranslations from '../features/ApplicationHeader/components/ApplicationHeaderMessages';
import applicationOverviewTranslations from '../features/ApplicationOverview/components/ApplicationOverviewComponentMessages';
import applyForBenfitsTranslations from '../features/ApplyForBenefits/components/ApplyForBenefitsComponentMessages';
import loginTranslations from '../features/Login/components/LoginComponentMessages';
import paymentTranslations from '../features/Payments/components/PaymentMessages';
import signupTranslations from '../features/Signup/components/SignupComponentMessages';
import routeTranslations from './RoutesMessages';
import verificationsTranslations from '../features/ApplicationVerifications/components/ApplicationVerificationsComponentMessages';
import PATHS from './Paths';
import featureToggles from '../features/featureToggles';
var Organization = Loadable({
  loader: function loader() {
    return import(
    /* webpackChunkName: "Organisation" */
    '../features/Organisation');
  },
  loading: LoadingPage
});
var AccountHome = Loadable({
  loader: function loader() {
    return import(
    /* webpackChunkName: "AccountHome" */
    '../features/AccountHome');
  },
  loading: LoadingPage
});
var YourBenefits = Loadable({
  loader: function loader() {
    return import(
    /* webpackChunkName: "YourBenefits" */
    '../features/YourBenefits');
  },
  loading: LoadingPage
});
var Login = Loadable({
  loader: function loader() {
    return import(
    /* webpackChunkName: "Login" */
    '../features/Login');
  },
  loading: LoadingPage
});
var LifeEventsConfirmation = Loadable({
  loader: function loader() {
    return import(
    /* webpackChunkName: "LifeEventsConfirmation" */
    '../features/LifeEventsConfirmation');
  },
  loading: LoadingPage
});
var Profile = Loadable({
  loader: function loader() {
    return import(
    /* webpackChunkName: "Profile" */
    '../features/Profile');
  },
  loading: LoadingPage
});
var Payments = Loadable({
  loader: function loader() {
    return import(
    /* webpackChunkName: "Payments" */
    '../features/Payments');
  },
  loading: LoadingPage
});
var Signup = Loadable({
  loader: function loader() {
    return import(
    /* webpackChunkName: "Signup" */
    '../features/Signup');
  },
  loading: LoadingPage
});
var ApplicationOverview = Loadable({
  loader: function loader() {
    return import(
    /* webpackChunkName: "ApplicationOverview" */
    '../features/ApplicationOverview');
  },
  loading: LoadingPage
});
var ApplyForBenefits = Loadable({
  loader: function loader() {
    return import(
    /* webpackChunkName: "ApplyForBenefits" */
    '../features/ApplyForBenefits');
  },
  loading: LoadingPage
});
var BenefitSelection = Loadable({
  loader: function loader() {
    return import(
    /* webpackChunkName: "BenefitSelection" */
    '../features/BenefitSelection');
  },
  loading: LoadingPage
});
var ContactUs = Loadable({
  loader: function loader() {
    return import(
    /* webpackChunkName: "ContactUs" */
    '../features/ContactUs');
  },
  loading: LoadingPage
});
var SpecificPayment = Loadable({
  loader: function loader() {
    return import(
    /* webpackChunkName: "SpecificPayment" */
    '../features/SpecificPayment');
  },
  loading: LoadingPage
});
var FAQ = Loadable({
  loader: function loader() {
    return import(
    /* webpackChunkName: "FAQ" */
    '../features/FAQ');
  },
  loading: LoadingPage
});
var PageNotFound = Loadable({
  loader: function loader() {
    return import(
    /* webpackChunkName: "PageNotFound" */
    './components/PageNotFound');
  },
  loading: LoadingPage
});
var ApplicationForm = Loadable({
  loader: function loader() {
    return import(
    /* webpackChunkName: "ApplicationForm" */
    '../features/Forms/ApplicationForm');
  },
  loading: LoadingPage
});
var SubmissionForm = Loadable({
  loader: function loader() {
    return import(
    /* webpackChunkName: "SubmissionForm" */
    '../features/Forms/SubmissionForm');
  },
  loading: LoadingPage
});
var SubmissionFormResolve = Loadable({
  loader: function loader() {
    return import(
    /* webpackChunkName: "SubmissionFormResolve" */
    '../features/Forms/SubmissionForm/SubmissionFormResolveComponent');
  },
  loading: LoadingPage
});
var SubmissionFormConfirmation = Loadable({
  loader: function loader() {
    return import(
    /* webpackChunkName: "SubmissionFormConfirmation" */
    '../features/Forms/SubmissionForm/SubmissionFormConfirmationComponent');
  },
  loading: LoadingPage
});
var AppealRequestsConfirmationComponent = Loadable({
  loader: function loader() {
    return import(
    /* webpackChunkName: "AppealRequestsConfirmationComponent" */
    '../features/AppealRequestsConfirmation/AppealRequestsConfirmationComponent');
  },
  loading: LoadingPage
});
var EligibilityHome = Loadable({
  loader: function loader() {
    return import(
    /* webpackChunkName: "EligibilityHome" */
    '../features/EligibilityHome');
  },
  loading: LoadingPage
});
var EligibilityBenefitSelection = Loadable({
  loader: function loader() {
    return import(
    /* webpackChunkName: "EligibilityBenefitSelection" */
    '../features/EligibilityBenefitSelection');
  },
  loading: LoadingPage
});
var EligibilityForm = Loadable({
  loader: function loader() {
    return import(
    /* webpackChunkName: "Eligibility" */
    '../features/Forms/Eligibility');
  },
  loading: LoadingPage
});
var LifeEventsForm = Loadable({
  loader: function loader() {
    return import(
    /* webpackChunkName: "LifeEvents" */
    '../features/Forms/LifeEvents');
  },
  loading: LoadingPage
});
var FilterEligibilityFormContainer = Loadable({
  loader: function loader() {
    return import(
    /* webpackChunkName: "FilterEligibility" */
    '../features/Forms/FilterEligibility');
  },
  loading: LoadingPage
});
var EligibilityResults = Loadable({
  loader: function loader() {
    return import(
    /* webpackChunkName: "EligibilityResults" */
    '../features/EligibilityResults');
  },
  loading: LoadingPage
});
var LifeEventsHistory = Loadable({
  loader: function loader() {
    return import(
    /* webpackChunkName: "LifeEventsHistory" */
    '../features/LifeEventsHistory');
  },
  loading: LoadingPage
});
var LifeEventsOverview = Loadable({
  loader: function loader() {
    return import(
    /* webpackChunkName: "LifeEventsOverview" */
    '../features/LifeEventsOverview');
  },
  loading: LoadingPage
});
var LifeEventsRemoteSystems = Loadable({
  loader: function loader() {
    return import(
    /* webpackChunkName: "LifeEventsHistory" */
    '../features/LifeEventsRemoteSystems');
  },
  loading: LoadingPage
});
var AppealRequests = Loadable({
  loader: function loader() {
    return import(
    /* webpackChunkName: "AppealRequests" */
    '../features/AppealRequests');
  },
  loading: LoadingPage
});
var Notices = Loadable({
  loader: function loader() {
    return import(
    /* webpackChunkName: "Notices" */
    '../features/Notices');
  },
  loading: LoadingPage
});
var NoticeDetails = Loadable({
  loader: function loader() {
    return import(
    /* webpackChunkName: "NoticeDetails" */
    '../features/NoticeDetails');
  },
  loading: LoadingPage
});
var AppealOverview = Loadable({
  loader: function loader() {
    return import(
    /* webpackChunkName: "AppealOverview" */
    '../features/AppealOverview');
  },
  loading: LoadingPage
});
var AppealForm = Loadable({
  loader: function loader() {
    return import(
    /* webpackChunkName: "Appeals" */
    '../features/Forms/Appeals');
  },
  loading: LoadingPage
});
var Verifications = Loadable({
  loader: function loader() {
    return import(
    /* webpackChunkName: "Verifications" */
    '../features/Verifications');
  },
  loading: LoadingPage
});
var VerificationDetail = Loadable({
  loader: function loader() {
    return import(
    /* webpackChunkName: "VerificationDetail" */
    '../features/VerificationDetail');
  },
  loading: LoadingPage
});
var ApplicationVerifications = Loadable({
  loader: function loader() {
    return import(
    /* webpackChunkName: "ApplicationVerifications" */
    '../features/ApplicationVerifications');
  },
  loading: LoadingPage
});
/**
 * Closes any dialog opened before the popstate event.
 */

var handlePopState = function handlePopState() {
  window.govhhswds.dialog.close(document);
};
/**
 * React Router Switch component which contains the routes exposed by the universal-access-ui
 * module.
 * @namespace
 */


var Routes = /*#__PURE__*/function (_Component) {
  _inherits(Routes, _Component);

  var _super = _createSuper(Routes);

  function Routes() {
    _classCallCheck(this, Routes);

    return _super.apply(this, arguments);
  }

  _createClass(Routes, [{
    key: "componentDidMount",

    /**
     * Listens to route changes to dispatch a location changed action.
     *
     * @memberof Routes
     */
    value: function componentDidMount() {
      var _this$props = this.props,
          history = _this$props.history,
          routeLocationChanged = _this$props.routeLocationChanged;
      history.listen(function (location) {
        routeLocationChanged(location);
      });
      window.addEventListener('popstate', handlePopState);
    }
    /**
     * Removes the popstate event listener.
     */

  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('popstate', handlePopState);
    }
    /**
     * Renders the routes
     *
     * @memberof Routes
     */

  }, {
    key: "render",
    value: function render() {
      var _context, _context2, _context3, _context4, _context5, _context6, _context7, _context8, _context9, _context10, _context11, _context12, _context13, _context14, _context15, _context16, _context17;

      return /*#__PURE__*/React.createElement(Switch, null, /*#__PURE__*/React.createElement(TitledRoute, {
        component: Organization,
        exact: true,
        path: PATHS.HOME,
        title: applicationHeaderTranslations.headerLandingPageTitle
      }), /*#__PURE__*/React.createElement(TitledRoute, {
        component: Login,
        exact: true,
        path: PATHS.LOGIN,
        title: loginTranslations.title
      }), /*#__PURE__*/React.createElement(TitledRoute, {
        component: Signup,
        exact: true,
        path: PATHS.SIGNUP,
        title: signupTranslations.title
      }), /*#__PURE__*/React.createElement(TitledRoute, {
        component: BenefitSelection,
        exact: true,
        path: PATHS.BENEFIT_SELECTION,
        title: routeTranslations.benefitSelection
      }), /*#__PURE__*/React.createElement(TitledRoute, {
        component: ApplicationOverview,
        exact: true,
        path: PATHS.APPLICATION_OVERVIEW,
        title: applicationOverviewTranslations.overviewTitle
      }), /*#__PURE__*/React.createElement(TitledRoute, {
        component: ApplicationOverview,
        exact: true,
        path: _concatInstanceProperty(_context = "").call(_context, PATHS.APPLICATION_OVERVIEW, "/:intakeApplicationTypeId/:programIds"),
        title: applicationOverviewTranslations.overviewTitle
      }), /*#__PURE__*/React.createElement(TitledRoute, {
        component: ContactUs,
        exact: true,
        path: PATHS.CONTACT_US,
        title: applicationHeaderTranslations.headerContactUsLabel
      }), /*#__PURE__*/React.createElement(TitledRoute, {
        component: ApplyForBenefits,
        exact: true,
        path: PATHS.APPLY,
        title: applyForBenfitsTranslations.applyForBenefitsPageTitle
      }), /*#__PURE__*/React.createElement(TitledRoute, {
        component: ApplicationForm,
        exact: true,
        isIEG: true,
        path: _concatInstanceProperty(_context2 = "").call(_context2, PATHS.APPLY, "/new/:applicationTypeId"),
        title: routeTranslations.applicationForm
      }), /*#__PURE__*/React.createElement(TitledRoute, {
        component: ApplicationForm,
        exact: true,
        isIEG: true,
        path: _concatInstanceProperty(_context3 = "").call(_context3, PATHS.APPLY, "/:applicationFormId"),
        title: routeTranslations.applicationForm
      }), /*#__PURE__*/React.createElement(TitledRoute, {
        component: SubmissionForm,
        exact: true,
        isIEG: true,
        path: _concatInstanceProperty(_context4 = "").call(_context4, PATHS.APPLY, "/:submissionFormId/submit"),
        title: routeTranslations.submissionForm
      }), /*#__PURE__*/React.createElement(TitledRoute, {
        component: SubmissionForm,
        exact: true,
        isIEG: true,
        path: _concatInstanceProperty(_context5 = "").call(_context5, PATHS.APPLY, "/new/:applicationFormId/submit"),
        title: routeTranslations.submissionForm
      }), /*#__PURE__*/React.createElement(TitledRoute, {
        component: SubmissionFormResolve,
        exact: true,
        path: _concatInstanceProperty(_context6 = "").call(_context6, PATHS.APPLY, "/:applicationFormId/success"),
        title: routeTranslations.submissionFormResolve
      }), /*#__PURE__*/React.createElement(TitledRoute, {
        component: SubmissionFormConfirmation,
        exact: true,
        path: _concatInstanceProperty(_context7 = "").call(_context7, PATHS.APPLY, "/:applicationFormId/confirm"),
        title: routeTranslations.submissionFormConfirmation
      }), /*#__PURE__*/React.createElement(TitledRoute, {
        component: FAQ,
        exact: true,
        path: PATHS.FAQS,
        title: applicationHeaderTranslations.headerFAQLabel
      }), /*#__PURE__*/React.createElement(TitledRoute, {
        component: EligibilityHome,
        exact: true,
        path: PATHS.ELIGIBILITY.ROOT,
        title: routeTranslations.eligibilityHomeLabel
      }), /*#__PURE__*/React.createElement(TitledRoute, {
        component: EligibilityBenefitSelection,
        exact: true,
        path: _concatInstanceProperty(_context8 = "").call(_context8, PATHS.ELIGIBILITY.BENEFIT_SELECTION, "/:formId?"),
        title: routeTranslations.eligibilityBenefitSelectionLabel
      }), /*#__PURE__*/React.createElement(TitledRoute, {
        component: EligibilityForm,
        isIEG: true,
        path: PATHS.ELIGIBILITY.FORM,
        title: routeTranslations.eligibilityFormContainerLabel
      }), /*#__PURE__*/React.createElement(TitledRoute, {
        component: EligibilityForm,
        exact: true,
        isIEG: true,
        path: _concatInstanceProperty(_context9 = "").call(_context9, PATHS.ELIGIBILITY.RESUME, "/:formId"),
        title: routeTranslations.eligibilityFormContainerResumeLabel
      }), featureToggles.lifeEvents.isEnabled() && /*#__PURE__*/React.createElement(AuthenticatedRoute, {
        authUserTypes: [Authentication.USER_TYPES.LINKED],
        component: LifeEventsForm,
        isIEG: true,
        path: _concatInstanceProperty(_context10 = "").call(_context10, PATHS.LIFE_EVENTS.FORM, "/:lifeEventContextId"),
        title: routeTranslations.lifeEventsFormContainerLabel
      }), featureToggles.lifeEvents.isEnabled() && /*#__PURE__*/React.createElement(AuthenticatedRoute, {
        authUserTypes: [Authentication.USER_TYPES.LINKED],
        component: LifeEventsForm,
        exact: true,
        isIEG: true,
        path: _concatInstanceProperty(_context11 = "").call(_context11, PATHS.LIFE_EVENTS.RESUME, "/:formId"),
        title: routeTranslations.lifeEventsFormContainerResumeLabel
      }), featureToggles.lifeEvents.isEnabled() && /*#__PURE__*/React.createElement(AuthenticatedRoute, {
        authUserTypes: [Authentication.USER_TYPES.LINKED],
        component: LifeEventsHistory,
        exact: true,
        path: PATHS.LIFE_EVENTS.HISTORY,
        title: routeTranslations.lifeEventsHistoryLabel
      }), featureToggles.lifeEvents.isEnabled() && /*#__PURE__*/React.createElement(AuthenticatedRoute, {
        authUserTypes: [Authentication.USER_TYPES.LINKED],
        component: LifeEventsOverview,
        path: _concatInstanceProperty(_context12 = "").call(_context12, PATHS.LIFE_EVENTS.OVERVIEW, "/:contextId"),
        title: routeTranslations.lifeEventsOverviewLabel
      }), featureToggles.lifeEvents.isEnabled() && /*#__PURE__*/React.createElement(AuthenticatedRoute, {
        authUserTypes: [Authentication.USER_TYPES.LINKED],
        component: LifeEventsRemoteSystems,
        exact: true,
        path: _concatInstanceProperty(_context13 = "").call(_context13, PATHS.LIFE_EVENTS.ROOT, "/:formId/remote-systems"),
        title: routeTranslations.lifeEventsRemoteSystemsLabel
      }), /*#__PURE__*/React.createElement(TitledRoute, {
        component: FilterEligibilityFormContainer,
        isIEG: true,
        path: PATHS.ELIGIBILITY.FILTER_FORM,
        title: routeTranslations.eligibilityFilterFormContainerLabel
      }), /*#__PURE__*/React.createElement(TitledRoute, {
        component: FilterEligibilityFormContainer,
        isIEG: true,
        path: _concatInstanceProperty(_context14 = "").call(_context14, PATHS.ELIGIBILITY.FILTER_FORM_RESUME, "/:formId"),
        title: routeTranslations.eligibilityFilterFormContainerLabel
      }), /*#__PURE__*/React.createElement(TitledRoute, {
        component: EligibilityResults,
        exact: true,
        path: _concatInstanceProperty(_context15 = "").call(_context15, PATHS.ELIGIBILITY.ROOT, "/:screeningFormId/results"),
        title: routeTranslations.eligibilityResultsLabel
      }), /*#__PURE__*/React.createElement(AuthenticatedRoute, {
        authUserTypes: [Authentication.USER_TYPES.STANDARD, Authentication.USER_TYPES.LINKED],
        component: AccountHome,
        exact: true,
        path: PATHS.ACCOUNT,
        title: applicationHeaderTranslations.headerDashboardLabel
      }), /*#__PURE__*/React.createElement(AuthenticatedRoute, {
        authUserTypes: [Authentication.USER_TYPES.STANDARD, Authentication.USER_TYPES.LINKED],
        component: YourBenefits,
        exact: true,
        path: PATHS.BENEFITS,
        title: applicationHeaderTranslations.headerYourBenefitsLabel
      }), /*#__PURE__*/React.createElement(AuthenticatedRoute, {
        authUserTypes: [Authentication.USER_TYPES.LINKED],
        component: LifeEventsConfirmation,
        exact: true,
        path: _concatInstanceProperty(_context16 = "").call(_context16, PATHS.LIFE_EVENTS.ROOT, "/:formId/success"),
        title: routeTranslations.lifeEventsConfirmation
      }), /*#__PURE__*/React.createElement(AuthenticatedRoute, {
        authUserTypes: [Authentication.USER_TYPES.STANDARD, Authentication.USER_TYPES.LINKED],
        component: Profile,
        exact: true,
        path: PATHS.PROFILE,
        title: applicationHeaderTranslations.headerProfileText
      }), /*#__PURE__*/React.createElement(AuthenticatedRoute, {
        authUserTypes: [Authentication.USER_TYPES.STANDARD, Authentication.USER_TYPES.LINKED],
        component: Payments,
        exact: true,
        path: PATHS.PAYMENTS.ROOT,
        title: paymentTranslations.paymentListPageTitleAllPayments
      }), /*#__PURE__*/React.createElement(AuthenticatedRoute, {
        authUserTypes: [Authentication.USER_TYPES.STANDARD, Authentication.USER_TYPES.LINKED],
        component: SpecificPayment,
        exact: true,
        path: PATHS.PAYMENTS.DETAILS,
        title: routeTranslations.paymentBreakdown
      }), /*#__PURE__*/React.createElement(AuthenticatedRoute, {
        authUserTypes: [Authentication.USER_TYPES.STANDARD, Authentication.USER_TYPES.LINKED],
        component: Notices,
        exact: true,
        path: PATHS.NOTICES.ROOT,
        title: applicationHeaderTranslations.headerNoticesLabel
      }), /*#__PURE__*/React.createElement(AuthenticatedRoute, {
        authUserTypes: [Authentication.USER_TYPES.STANDARD, Authentication.USER_TYPES.LINKED],
        component: NoticeDetails,
        exact: true,
        path: PATHS.NOTICES.DETAILS,
        title: routeTranslations.noticeDetails
      }), featureToggles.appeals.isEnabled() && /*#__PURE__*/React.createElement(AuthenticatedRoute, {
        authUserTypes: [Authentication.USER_TYPES.STANDARD, Authentication.USER_TYPES.LINKED],
        component: AppealRequests,
        exact: true,
        path: PATHS.APPEALS.ROOT,
        title: applicationHeaderTranslations.headerAppealsLabel
      }), featureToggles.appeals.isEnabled() && /*#__PURE__*/React.createElement(AuthenticatedRoute, {
        authUserTypes: [Authentication.USER_TYPES.STANDARD, Authentication.USER_TYPES.LINKED],
        component: AppealOverview,
        exact: true,
        path: PATHS.APPEALS.OVERVIEW,
        title: routeTranslations.appealOverviewLabel
      }), featureToggles.appeals.isEnabled() && /*#__PURE__*/React.createElement(TitledRoute, {
        component: AppealForm,
        isIEG: true,
        path: PATHS.APPEALS.FORM,
        title: routeTranslations.appealForm
      }), featureToggles.appeals.isEnabled() && /*#__PURE__*/React.createElement(TitledRoute, {
        component: AppealForm,
        exact: true,
        isIEG: true,
        path: _concatInstanceProperty(_context17 = "").call(_context17, PATHS.APPEALS.RESUME, "/:formId"),
        title: routeTranslations.appealDetails
      }), featureToggles.appeals.isEnabled() && /*#__PURE__*/React.createElement(TitledRoute, {
        component: AppealRequestsConfirmationComponent,
        exact: true,
        path: PATHS.APPEALS.SUBMITTED,
        title: routeTranslations.appealRequestConfirmation
      }), featureToggles.verifications.isEnabled() && /*#__PURE__*/React.createElement(AuthenticatedRoute, {
        authUserTypes: [Authentication.USER_TYPES.LINKED],
        component: Verifications,
        exact: true,
        path: PATHS.VERIFICATIONS.ROOT,
        title: applicationHeaderTranslations.headerYourVerificationsText
      }), featureToggles.verifications.isEnabled() && /*#__PURE__*/React.createElement(AuthenticatedRoute, {
        authUserTypes: [Authentication.USER_TYPES.LINKED],
        component: VerificationDetail,
        exact: true,
        path: PATHS.VERIFICATIONS.DETAILS,
        title: routeTranslations.verificationDetails
      }), featureToggles.verifications.isEnabled() && /*#__PURE__*/React.createElement(AuthenticatedRoute, {
        authUserTypes: [Authentication.USER_TYPES.LINKED],
        component: ApplicationVerifications,
        exact: true,
        path: PATHS.IEGVERIFICATIONS.ROOT,
        title: verificationsTranslations.routeTitle
      }), featureToggles.verifications.isEnabled() && /*#__PURE__*/React.createElement(AuthenticatedRoute, {
        authUserTypes: [Authentication.USER_TYPES.LINKED],
        component: VerificationDetail,
        exact: true,
        path: PATHS.IEGVERIFICATIONS.DETAILS,
        title: verificationsTranslations.iegVerificationDetailsRouteTitle
      }), this.props.pageNotFound);
    }
  }]);

  return Routes;
}(Component);

Routes.propTypes = process.env.NODE_ENV !== "production" ? {
  history: PropTypes.object.isRequired,
  pageNotFound: PropTypes.element,
  routeLocationChanged: PropTypes.func.isRequired
} : {};
Routes.defaultProps = {
  pageNotFound: /*#__PURE__*/React.createElement(TitledRoute, {
    component: PageNotFound,
    path: "*",
    title: routeTranslations.pageNotFound
  })
};
/**
 * Redux action creators that will be merged into the component props.
 *
 * @export
 * @param {any} dispatch the dispatch function
 * @returns the action creators
 */

export function mapDispatchToProps(dispatch) {
  return {
    routeLocationChanged: function routeLocationChanged(location) {
      CoreReduxActions.routeLocationChanged(dispatch, location);
    }
  };
}
/**
 * Used to subscribe to Redux store updates. This will be called any time the store is updated. Will
 * be merged into the component props.
 *
 * @param {*} state the store state
 */

var mapStateToProps = function mapStateToProps() {
  return {};
};
/**
 * Contains the routes that are mapped to pages in the universal access library.
 */


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Routes));